import { TrackTicketView as SdkTrackTicketView } from '@reqdesk/sdk-react'

interface TrackTicketViewProps {
  onTrackSuccess: (ticketId: string) => void
}

export function TrackTicketView({ onTrackSuccess }: TrackTicketViewProps) {
  return <SdkTrackTicketView onTrackSuccess={onTrackSuccess} />
}
